/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-undef */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class OrderFormEmptyPlaceholder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showGuideModal: false,
      showPolicyModal: false,
    };

    this.handleGuideModalShow = this.handleGuideModalShow.bind(this);
    this.handleGuideModalClose = this.handleGuideModalClose.bind(this);
    this.handlePolicyModalShow = this.handlePolicyModalShow.bind(this);
    this.handlePolicyModalClose = this.handlePolicyModalClose.bind(this);
  }

  handleGuideModalShow() {
    this.setState({
      showGuideModal: true,
    });
  }

  handleGuideModalClose() {
    this.setState({
      showGuideModal: false,
    });
  }

  handlePolicyModalShow() {
    this.setState({
      showPolicyModal: true,
    });
  }

  handlePolicyModalClose() {
    this.setState({
      showPolicyModal: false,
    });
  }

  render() {
    const {
      guide,
      policy,
    } = this.props;

    return (
      <div className="information-dropdown">
        <h4>{I18n.t('sidebar.order.title')}</h4>

        <span className="bold">{I18n.t('sidebar.order.errors.choose_location_or_fill_in_details')}</span>
        {guide && (
        <span
          className="button--link"
          role="button"
          tabIndex={0}
          onKeyPress={() => {}}
          onClick={this.handleGuideModalShow}
        >
          (?)
        </span>
        )}

        {policy && (
        <div
          className="button--link privacy-url"
          onClick={this.handlePolicyModalShow}
          onKeyPress={() => {}}
          role="button"
          tabIndex={0}
        >
          {I18n.t('sidebar.order.privacy_link')}
        </div>
        )}

        {guide && (
          <Modal
            className="header-modals"
            show={this.state.showGuideModal}
            onHide={this.handleGuideModalClose}
          >
            <Modal.Header closeButton />
            <Modal.Body>
              <div dangerouslySetInnerHTML={{ __html: guide }} />
            </Modal.Body>
          </Modal>
        )}

        {policy && (
          <Modal
            className="header-modals"
            show={this.state.showPolicyModal}
            onHide={this.handlePolicyModalClose}
          >
            <Modal.Header closeButton />
            <Modal.Body>
              <div dangerouslySetInnerHTML={{ __html: policy }} />
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  }
}

OrderFormEmptyPlaceholder.propTypes = {
  guide: PropTypes.string,
  policy: PropTypes.string,
};

OrderFormEmptyPlaceholder.defaultProps = {
  guide: '',
  policy: '',
};

export default OrderFormEmptyPlaceholder;
